import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 50vw;
	max-width: 600px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1.5rem;

	@media (max-width: 500px) {
		width: 100%;
		max-width: 100%;
	}
`;

export const tabs = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
`;

export const content = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	overflow: auto;
	box-sizing: content-box;
`;

export const twoInputs = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.5rem;

	@media (max-width: 1000px) {
		grid-template-columns: 1fr;
	}
`;
